module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img18.7f1343d4.jpg";